import { BaseModel, HasMany } from './base-model'
import { User } from './user'

export class SharingGroup extends BaseModel {
  public id: number
  public name: string
  @HasMany(User) public users: User[]
  public usersCount: number
}



// WEBPACK FOOTER //
// ./src/models/sharing-group.ts